import * as Sentry from '@sentry/react'

export type BugFixEvent = {
  type:
    | 'bugfix_session_status'
    | 'bugfix_discovery_done'
    | 'bugfix_issue_update'
    | 'bugfix_stream'
    | 'ping'
    | 'error'
  session_id?: number
  status?: string
  total_issues?: number
  pr_created?: number
  not_a_bug?: number
  escalated?: number
  skipped?: number
  failed?: number
  duplicate?: number
  issue_id?: number
  step?: string
  result?: string
  content?: string
  tool_name?: string
  tool_input?: string
  tool_result?: string
  detail?: string
  error_message?: string
  [key: string]: unknown
}

export function createBugFixSocket(
  onEvent: (event: BugFixEvent) => void,
  onClose?: () => void,
) {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const ws = new WebSocket(`${protocol}//${window.location.host}/api/bugfix/ws`)

  ws.onmessage = (e) => {
    try {
      const event: BugFixEvent = JSON.parse(e.data)
      if (event.type === 'ping') return
      if (event.type === 'error') {
        Sentry.captureMessage(`BugFix error: ${event.detail ?? 'Unknown'}`, 'error')
      }
      onEvent(event)
    } catch {
      console.error('Failed to parse bugfix event:', e.data)
    }
  }

  ws.onclose = () => onClose?.()

  const close = () => ws.close()

  return { close, ws }
}
